namespace RioERP.Carts {
    export interface CartProductsRow {
        Id?: number;
        CartId?: number;
        ProductId?: number;
        Quantity?: number;
        AllowedDevice?: number[];
        Cost?: number;
        GrossAmount?: number;
        DiscountAmt?: number;
        NetAmount?: number;
        NetAmountAfterFrDiscount?: number;
        TaxableAmount?: number;
        TaxAmount?: number;
        SerialKey?: string;
        HasPendrive?: boolean;
        HasBooks?: boolean;
        HasCourier?: boolean;
        DownloadUrl1?: string;
        DownloadUrl2?: string;
        IsActive?: boolean;
        InvoiceCompanyId?: number;
        FranchiseeDiscountAmount?: number;
        FranchiseeDiscountValue?: number;
        EFranchiseeDiscountType?: number;
        EOpens?: number;
        EWatchTime?: number;
        EValidity?: number;
        EValidityType?: number;
        ValidTill?: string;
        TotalAllowedDuration?: number;
        AllowedDevices?: string;
        IsLive?: boolean;
        EAccessStatus?: number;
        IsTemplateSerialKey?: boolean;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        Note?: string;
        ESerialkeyStatus?: number;
        CartName?: string;
        CartFranchiseeId?: number;
        CartCustomerId?: number;
        CartCustomerName?: string;
        CartCustomerEmail1?: string;
        CartCustomerEmail2?: string;
        CartCustomerMobile1?: string;
        CartCustomerMobile2?: string;
        CartShippingAddress1?: string;
        CartShippingAddress2?: string;
        CartShippingCity?: string;
        CartShippingStateId?: number;
        CartShippingPincode?: number;
        CartEInvoiceTo?: number;
        CartInvoiceCompanyId?: number;
        CartDiscountCoupon?: string;
        CartDiscountAmount?: number;
        CartGrossAmount?: number;
        CartNetAmount?: number;
        CartTaxableAmount?: number;
        CartEFranchiseeDiscountType?: number;
        CartEFranchiseeDiscount?: number;
        CartFranchiseeDiscountValue?: number;
        CartFranchiseeDiscountAmount?: number;
        CartInsertUserId?: number;
        CartInsertDate?: string;
        CartUpdateUserId?: number;
        CartUpdateDate?: string;
        CartIsActive?: boolean;
        CartProductSpecificationId?: number[];
        ProductProductName?: string;
        ProductDescription?: string;
        ProductSkuCode?: string;
        ProductEProductType?: number;
        ProductERioplayVersion?: number;
        ProductRioplayProductCode?: string;
        ProductDownloadUrl1?: string;
        ProductDownloadUrl2?: string;
        ProductHasPenDrive?: boolean;
        ProductHasBooks?: boolean;
        ProductHasCourier?: boolean;
        ProductNote?: string;
        ProductWeight?: number;
        ProductHeight?: number;
        ProductWidth?: number;
        ProductLength?: number;
        ProductEPackingType?: number;
        ProductGrossAmount?: number;
        ProductEOpens?: number;
        ProductEWatchTime?: number;
        ProductEValidity?: number;
        ProductEValidityType?: number;
        ProductValidTill?: string;
        ProductTotalAllowedDuration?: number;
        ProductAllowSerialKeyGeneration?: boolean;
        ProductAllowedDevices?: string;
        ProductIsLive?: boolean;
        ProductProcesOrderOnPaid?: boolean;
        ProductEAccessStatus?: number;
        ProductInAppDownload?: boolean;
        ProductHasVod?: boolean;
        ProductTemplateSerialKeyId?: number;
        ProductIsActive?: boolean;
        ProductInsertUserId?: number;
        ProductInsertDate?: string;
        ProductUpdateUserId?: number;
        ProductUpdateDate?: string;
        ProductVendorId?: number;
        ProductSupportInfo?: string;
        ProductProductQueryInfo?: string;
        ProductEShippedby?: number;
        ProductActivateSerialKey?: boolean;
        ProductIsCombo?: boolean;
        ProductProductIds?: string;
        ProductWebsiteUrl?: string;
        ProductTeacherName?: string;
        ProductRioPlayTenantId?: number;
        ProductSecretkey?: string;
        ProductThumbnail?: string;
        InvoiceCompanyName?: string;
        InvoiceCompanyAddress?: string;
        InvoiceCompanyGstIn?: string;
        InvoiceCompanyInvoiceCode?: string;
        InvoiceCompanyIsTaxApplicable?: boolean;
        InvoiceCompanyInvoiceChangeDate?: string;
        InvoiceCompanyIsDefault?: boolean;
        InvoiceCompanyFooterNote?: string;
        InvoiceCompanyLogo1?: string;
        InvoiceCompanyLogo2?: string;
        InvoiceCompanyStampImage?: string;
        InvoiceCompanyDisableInvoiceGenration?: boolean;
        InvoiceCompanyTaxApplicable?: number;
    }

    export namespace CartProductsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SerialKey';
        export const localTextPrefix = 'Carts.CartProducts';
        export const deletePermission = 'Carts:CartsManagement:Modify';
        export const insertPermission = 'Carts:CartsManagement:Modify';
        export const readPermission = 'Carts:CartsManagement:View';
        export const updatePermission = 'Carts:CartsManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            CartId = "CartId",
            ProductId = "ProductId",
            Quantity = "Quantity",
            AllowedDevice = "AllowedDevice",
            Cost = "Cost",
            GrossAmount = "GrossAmount",
            DiscountAmt = "DiscountAmt",
            NetAmount = "NetAmount",
            NetAmountAfterFrDiscount = "NetAmountAfterFrDiscount",
            TaxableAmount = "TaxableAmount",
            TaxAmount = "TaxAmount",
            SerialKey = "SerialKey",
            HasPendrive = "HasPendrive",
            HasBooks = "HasBooks",
            HasCourier = "HasCourier",
            DownloadUrl1 = "DownloadUrl1",
            DownloadUrl2 = "DownloadUrl2",
            IsActive = "IsActive",
            InvoiceCompanyId = "InvoiceCompanyId",
            FranchiseeDiscountAmount = "FranchiseeDiscountAmount",
            FranchiseeDiscountValue = "FranchiseeDiscountValue",
            EFranchiseeDiscountType = "EFranchiseeDiscountType",
            EOpens = "EOpens",
            EWatchTime = "EWatchTime",
            EValidity = "EValidity",
            EValidityType = "EValidityType",
            ValidTill = "ValidTill",
            TotalAllowedDuration = "TotalAllowedDuration",
            AllowedDevices = "AllowedDevices",
            IsLive = "IsLive",
            EAccessStatus = "EAccessStatus",
            IsTemplateSerialKey = "IsTemplateSerialKey",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            Note = "Note",
            ESerialkeyStatus = "ESerialkeyStatus",
            CartName = "CartName",
            CartFranchiseeId = "CartFranchiseeId",
            CartCustomerId = "CartCustomerId",
            CartCustomerName = "CartCustomerName",
            CartCustomerEmail1 = "CartCustomerEmail1",
            CartCustomerEmail2 = "CartCustomerEmail2",
            CartCustomerMobile1 = "CartCustomerMobile1",
            CartCustomerMobile2 = "CartCustomerMobile2",
            CartShippingAddress1 = "CartShippingAddress1",
            CartShippingAddress2 = "CartShippingAddress2",
            CartShippingCity = "CartShippingCity",
            CartShippingStateId = "CartShippingStateId",
            CartShippingPincode = "CartShippingPincode",
            CartEInvoiceTo = "CartEInvoiceTo",
            CartInvoiceCompanyId = "CartInvoiceCompanyId",
            CartDiscountCoupon = "CartDiscountCoupon",
            CartDiscountAmount = "CartDiscountAmount",
            CartGrossAmount = "CartGrossAmount",
            CartNetAmount = "CartNetAmount",
            CartTaxableAmount = "CartTaxableAmount",
            CartEFranchiseeDiscountType = "CartEFranchiseeDiscountType",
            CartEFranchiseeDiscount = "CartEFranchiseeDiscount",
            CartFranchiseeDiscountValue = "CartFranchiseeDiscountValue",
            CartFranchiseeDiscountAmount = "CartFranchiseeDiscountAmount",
            CartInsertUserId = "CartInsertUserId",
            CartInsertDate = "CartInsertDate",
            CartUpdateUserId = "CartUpdateUserId",
            CartUpdateDate = "CartUpdateDate",
            CartIsActive = "CartIsActive",
            CartProductSpecificationId = "CartProductSpecificationId",
            ProductProductName = "ProductProductName",
            ProductDescription = "ProductDescription",
            ProductSkuCode = "ProductSkuCode",
            ProductEProductType = "ProductEProductType",
            ProductERioplayVersion = "ProductERioplayVersion",
            ProductRioplayProductCode = "ProductRioplayProductCode",
            ProductDownloadUrl1 = "ProductDownloadUrl1",
            ProductDownloadUrl2 = "ProductDownloadUrl2",
            ProductHasPenDrive = "ProductHasPenDrive",
            ProductHasBooks = "ProductHasBooks",
            ProductHasCourier = "ProductHasCourier",
            ProductNote = "ProductNote",
            ProductWeight = "ProductWeight",
            ProductHeight = "ProductHeight",
            ProductWidth = "ProductWidth",
            ProductLength = "ProductLength",
            ProductEPackingType = "ProductEPackingType",
            ProductGrossAmount = "ProductGrossAmount",
            ProductEOpens = "ProductEOpens",
            ProductEWatchTime = "ProductEWatchTime",
            ProductEValidity = "ProductEValidity",
            ProductEValidityType = "ProductEValidityType",
            ProductValidTill = "ProductValidTill",
            ProductTotalAllowedDuration = "ProductTotalAllowedDuration",
            ProductAllowSerialKeyGeneration = "ProductAllowSerialKeyGeneration",
            ProductAllowedDevices = "ProductAllowedDevices",
            ProductIsLive = "ProductIsLive",
            ProductProcesOrderOnPaid = "ProductProcesOrderOnPaid",
            ProductEAccessStatus = "ProductEAccessStatus",
            ProductInAppDownload = "ProductInAppDownload",
            ProductHasVod = "ProductHasVod",
            ProductTemplateSerialKeyId = "ProductTemplateSerialKeyId",
            ProductIsActive = "ProductIsActive",
            ProductInsertUserId = "ProductInsertUserId",
            ProductInsertDate = "ProductInsertDate",
            ProductUpdateUserId = "ProductUpdateUserId",
            ProductUpdateDate = "ProductUpdateDate",
            ProductVendorId = "ProductVendorId",
            ProductSupportInfo = "ProductSupportInfo",
            ProductProductQueryInfo = "ProductProductQueryInfo",
            ProductEShippedby = "ProductEShippedby",
            ProductActivateSerialKey = "ProductActivateSerialKey",
            ProductIsCombo = "ProductIsCombo",
            ProductProductIds = "ProductProductIds",
            ProductWebsiteUrl = "ProductWebsiteUrl",
            ProductTeacherName = "ProductTeacherName",
            ProductRioPlayTenantId = "ProductRioPlayTenantId",
            ProductSecretkey = "ProductSecretkey",
            ProductThumbnail = "ProductThumbnail",
            InvoiceCompanyName = "InvoiceCompanyName",
            InvoiceCompanyAddress = "InvoiceCompanyAddress",
            InvoiceCompanyGstIn = "InvoiceCompanyGstIn",
            InvoiceCompanyInvoiceCode = "InvoiceCompanyInvoiceCode",
            InvoiceCompanyIsTaxApplicable = "InvoiceCompanyIsTaxApplicable",
            InvoiceCompanyInvoiceChangeDate = "InvoiceCompanyInvoiceChangeDate",
            InvoiceCompanyIsDefault = "InvoiceCompanyIsDefault",
            InvoiceCompanyFooterNote = "InvoiceCompanyFooterNote",
            InvoiceCompanyLogo1 = "InvoiceCompanyLogo1",
            InvoiceCompanyLogo2 = "InvoiceCompanyLogo2",
            InvoiceCompanyStampImage = "InvoiceCompanyStampImage",
            InvoiceCompanyDisableInvoiceGenration = "InvoiceCompanyDisableInvoiceGenration",
            InvoiceCompanyTaxApplicable = "InvoiceCompanyTaxApplicable"
        }
    }
}
